import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-bayer-popup',
    templateUrl: './bayer-popup.component.html',
    styleUrls: ['./bayer-popup.component.scss']
})
export class BayerPopupComponent {
    @Output() closeDialogEvent: EventEmitter<void> = new EventEmitter<void>();

    dialogWidth: string | undefined;
    image = 'https://bayer-consent-static.s3.eu-central-1.amazonaws.com/bayer_dialog01.png';
}
